export default "__VITE_ASSET__BU30ZPos__"